import { shallowEqual } from "react-redux";
import { useAppSelector } from "redux-share";
import PinIcon from "../../icon-components/pinIcon";
import { useEffect, useState } from "react";
import TruncateMarkup from "react-truncate-markup";
import ArrowBottomIcon from "../../icon-components/arrowBottomIcon";
import { conditions } from "helpers";
import { ConditionName } from "interfaces";

const PinMessage = () => {
    const { pinMessage } = useAppSelector(({ chats: { pinMessage } }) => ({ pinMessage }), shallowEqual);
    const [showPinMessage, setShowPinMessage] = useState<boolean>(false);
    const [isTruncate, setIsTruncate] = useState<boolean>(false);

    useEffect(() => {
        setShowPinMessage(false);
    }, [pinMessage!.length]);

    return (
        <>
            {conditions(ConditionName.isTouchScreenPortrait) ? (
                <div className={`pl-mt-[55px] pl-p-3 pl-gap-2 pl-bg-main-lightPurple dark:pl-bg-main-dark`}>
                    {showPinMessage ? (
                        <div className="pl-flex pl-flex-col pl-gap-3 pl-overflow-auto pl-bg-main-lightPurple dark:pl-bg-main-dark">
                            <div className="pl-flex pl-flex-col pl-justify-between pl-absolute pl-right-0 pl-h-[calc(100%-80px)] pl-overflow-auto pl-px-3 pl-z-[1000] pl-bg-main-lightPurple dark:pl-bg-main-dark">
                                <div>
                                    <PinIcon className="pl-fill-secondary-900 dark:pl-fill-white !pl-float-start pl-ml-2 !pl-w-max" />
                                    <p className="pl-text-[13px] pl-font-bold pl-text-justify">{pinMessage}</p>
                                </div>
                                <button
                                    className="pl-border-[1.5px] pl-border-white dark:pl-border-secondary-300 pl-rounded-[8px] pl-w-full pl-py-2 pl-mb-3 pl-text-[14px] pl-font-medium pl-text-secondary-600 dark:pl-text-z-secondary-50"
                                    onClick={() => setShowPinMessage(false)}
                                >
                                    بستن پیام
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="pl-cursor-pointer pl-w-full pl-bg-main-lightPurple dark:pl-bg-main-dark">
                            <PinIcon className="pl-fill-secondary-900 dark:pl-fill-white !pl-float-start pl-ml-2 !pl-w-max" />
                            <TruncateMarkup
                                lines={4}
                                ellipsis={() => (
                                    <button
                                        className="pl-border-[1.5px] pl-border-white dark:pl-border-secondary-300 pl-rounded-[8px] pl-w-full pl-py-2 pl-mt-4 pl-text-[14px] pl-font-medium pl-text-secondary-600 dark:pl-text-z-secondary-50"
                                        onClick={() => setShowPinMessage(true)}
                                    >
                                        مشاهده کامل پیام پین شده
                                    </button>
                                )}
                            >
                                <p className="pl-text-[13px] pl-font-bold pl-w-full">{pinMessage}</p>
                            </TruncateMarkup>
                        </div>
                    )}
                </div>
            ) : (
                <div className={`pl-p-3 pl-gap-2 pl-bg-main-lightPurple dark:pl-bg-main-dark pl-w-full`}>
                    {showPinMessage ? (
                        <div className="pl-flex pl-flex-col pl-gap-3 pl-overflow-auto pl-bg-main-lightPurple dark:pl-bg-main-dark pl-w-full">
                            <div className="pl-flex pl-items-center pl-justify-between pl-cursor-pointer" onClick={() => setShowPinMessage(false)}>
                                <div className="pl-flex pl-items-center pl-flex-1">
                                    <PinIcon className="pl-fill-secondary-900 dark:pl-fill-white pl-float-start pl-ml-2 pl-w-max" />
                                    <p className="pl-text-[13px] pl-font-bold">پیام پین شده</p>
                                </div>
                                <ArrowBottomIcon className="pl-fill-gray-800 dark:pl-fill-secondary !pl-w-6 !pl-h-6 pl-rotate-180" />
                            </div>
                            <div className="pl-absolute pl-right-0 pl-mt-[36px] pl-w-full pl-h-max pl-max-h-[calc(100%-102px)] pl-overflow-auto pl-px-3 pl-pb-3 pl-border-t pl-border-z-secondary-600 dark:pl-border-secondary pl-pt-3 pl-z-[1000] pl-bg-main-lightPurple dark:pl-bg-main-dark">
                                <p className="pl-text-[13px] pl-text-justify">{pinMessage}</p>
                            </div>
                        </div>
                    ) : (
                        <div
                            className={`pl-flex pl-items-center pl-gap-5 ${isTruncate && "pl-cursor-pointer"}`}
                            onClick={() => (isTruncate ? setShowPinMessage(true) : () => {})}
                        >
                            <div className="pl-flex pl-items-center pl-gap-2">
                                <PinIcon className="pl-fill-secondary-900 dark:pl-fill-white pl-w-max" />
                                <TruncateMarkup
                                    onTruncate={(value) => setIsTruncate(value)}
                                    lines={1}
                                    ellipsis={() => (
                                        <span className="pl-mr-2">
                                            ...
                                            <ArrowBottomIcon className="pl-inline pl-fill-gray-800 dark:pl-fill-secondary !pl-w-6 !pl-h-6" />
                                        </span>
                                    )}
                                >
                                    <p className="pl-text-[13px] pl-font-bold">{pinMessage}</p>
                                </TruncateMarkup>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default PinMessage;
